import logo from '@assets/logo.svg';
import { Group, type GroupProps } from '@components/ui/atoms/Group';
import { Image } from '@components/ui/atoms/Image';
import { Text } from '@components/ui/atoms/Text';

type Props = {
  onClick?: () => void;
  isExpanded?: boolean;
  size?: 'sm' | 'md' | 'lg';
  padding?: GroupProps['padding'];
  p?: GroupProps['p'];
  px?: GroupProps['px'];
  py?: GroupProps['py'];
};

const SIZE_CONFIG = {
  sm: { height: '24px', width: '28px', fontSize: '14px' },
  md: { height: '32px', width: '37px', fontSize: '18px' },
  lg: { height: '40px', width: '46px', fontSize: '22px' },
} as const;

export const BrandLogo: React.FC<Props> = ({
  onClick,
  isExpanded = true,
  size = 'sm',
  padding,
  p,
  px,
  py,
}) => {
  const config = SIZE_CONFIG[size];

  return (
    <Group
      onClick={onClick}
      cursor={onClick ? 'button' : 'default'}
      flexWrap="nowrap"
      whiteSpace="nowrap"
      padding={padding}
      p={p}
      px={px}
      py={py}
    >
      <Image src={logo} height={config.height} width={config.width} />
      {isExpanded && (
        <Text fontSize={config.fontSize} color="title.dark" fontWeight="700">
          Bhutan Payments
        </Text>
      )}
    </Group>
  );
};
